import { colors } from '@factorialco/deprecated-design-system'

export const colorPicker = (type: string) => {
  switch (type) {
    case 'self':
      return colors.malibu1000

    case 'manager':
      return colors.purple1000

    case 'direct_reports':
      return colors.champagne1000

    case 'peers':
      return colors.lime1000

    default:
      return colors.grey800
  }
}
